import { api } from "@/api";

const preparationSlipStore = {
  state: {
    preparationSlips: [],
    preparationSlipTemplates: [],
    automaticPreparationSlipTemplates: [],
    scheduledPreparations: [],
    defaultDailySetting: [],
    preparationSlipProductUpdateFlag: false
  },
  getters: {
    getPreparationSlips(state) {
      return state.preparationSlips;
    },
    getPreparationSlipTemplates(state) {
      return state.preparationSlipTemplates;
    },
    getAutomaticPreparationSlipTemplates(state) {
      return state.automaticPreparationSlipTemplates;
    },
    getScheduledPreparations(state) {
      return state.scheduledPreparations;
    },
    getDefaultDailySetting(state) {
      return state.defaultDailySetting;
    },
    getPreparationSlipProductUpdateFlag(state) {
      return state.preparationSlipProductUpdateFlag;
    }
  },
  mutations: {
    setPreparationSlips(state, value) {
      state.preparationSlips = value;
    },
    addPreparationSlip(state, value) {
      state.preparationSlips.push(value);
    },
    setPreparationSlipTemplates(state, value) {
      state.preparationSlipTemplates = value;
    },
    addPreparationSlipTemplate(state, value) {
      state.preparationSlipTemplates.push(value);
    },
    setAutomaticPreparationSlipTemplates(state, value) {
      state.automaticPreparationSlipTemplates = value;
    },
    setScheduledPreparations(state, value) {
      state.scheduledPreparations = value;
    },
    addScheduledPreparation(state, value) {
      state.scheduledPreparations.push(value);
    },
    removeScheduledPreparation(state, id) {
      state.scheduledPreparations = state.scheduledPreparations.filter(
        x => x.id !== id
      );
    },
    setDefaultDailySetting(state, value) {
      state.defaultDailySetting = value;
    },
    setPreparationSlipProductUpdateFlag(state, value) {
      state.preparationSlipProductUpdateFlag = value;
    }
  },
  actions: {
    async loadPreparationSlips(context, payload) {
      const res = await api.getPreparationSlips(payload);
      context.commit("setPreparationSlips", res);
    },
    async addPreparationSlip(context, payload) {
      const res = await api.postPreparationSlip(payload);
      if (res) {
        context.commit("addPreparationSlip", res);
      }
    },
    async loadPreparationSlipTemplates(context, payload) {
      if (context.state.preparationSlipTemplates.length > 0) {
        setTimeout(async () => {
          const res = await api.getPreparationSlipTemplates(payload);
          context.commit("setPreparationSlipTemplates", res);
        }, 0);
        return;
      }
      const res = await api.getPreparationSlipTemplates(payload);
      context.commit("setPreparationSlipTemplates", res);
    },
    async addPreparationSlipTemplate(context, payload) {
      const res = await api.postPreparationSlipTemplate(payload);
      if (res) {
        context.commit("addPreparationSlipTemplate", res);
      }
    },
    async loadAutomaticPreparationSlipTemplates(context) {
      const res = await api.getAutomaticPreparationSlips();
      context.commit("setAutomaticPreparationSlipTemplates", res);
    },
    async loadScheduledPreparations(context) {
      const res = await api.getScheduledPreparations();
      context.commit("setScheduledPreparations", res);
    },
    async addScheduledPreparation(context, payload) {
      const res = await api.postScheduledPreparation(payload);
      context.commit("addScheduledPreparation", res);
    },
    async deleteScheduledPreparation(context, payload) {
      api.deleteScheduledPreparation(payload);
      context.commit("removeScheduledPreparation", payload);
    },
    async updateScheduledPreparation(context, payload) {
      const res = await api.patchScheduledPreparation(payload);
      context.commit("removeScheduledPreparation", res.id);
      context.commit("addScheduledPreparation", res);
    },
    async loadDefaultDailySetting(context, payload) {
      const res = await api.getDefaultDailyPreparationSlip(payload);
      context.commit("setDefaultDailySetting", res);
      return res;
    },
    async updateDefaultDailySetting(context, payload) {
      await api.updateDefaultDailyPreparationSlip(payload.id, payload);
      const res = await api.getDefaultDailyPreparationSlip(payload);
      context.commit("setDefaultDailySetting", res);
    },
    async setPreparationSlipProductUpdateFlag(context, value) {
      context.commit("setPreparationSlipProductUpdateFlag", value);
    }
  }
};

export default preparationSlipStore;
